export default __webpack_public_path__ + "static/media/package3.beb1f706.png";